const cities = [
  { name: "Hoover", zips: "35226, 35244" },
  { name: "Vestavia Hills", zips: "35216, 35223, 35243" },
  { name: "Pelham", zips: "35124" },
  { name: "Helena", zips: "35080" },
  { name: "Alabaster", zips: "35007" },
];

const benefits = [
  { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Riverchase home or office in minutes." },
  { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there." },
  { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays." },
  { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed." },
];

export default function HooverLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Hoover &amp; Greater Birmingham's South Suburbs
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Hoover is Alabama's fifth-largest city and the Birmingham metro area's most affluent suburb, anchoring a south Jefferson County and north Shelby County corridor that stretches from Vestavia Hills through Pelham and Helena to Alabaster. The Riverchase area, home to the Galleria shopping district and numerous corporate headquarters, positions Hoover as a white-collar professional hub for the entire Greater Birmingham metro. The executives, attorneys, physicians, and consultants who live and work in Hoover travel internationally at rates significantly above the Alabama average — and they do not always book their trips with six months of lead time.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Birmingham's medical economy radiates into Hoover through the UAB Health System, Brookwood Baptist Health, and a dense network of specialty practices that recruit physicians from across the country. Medical professionals — surgeons presenting at international conferences, researchers attending symposia in Europe, and residents completing rotations abroad — regularly need expedited passport processing with minimal disruption to patient care schedules. A surgeon cannot take three days off for an Atlanta agency appointment; they need a professional service that handles everything remotely.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Hoover's thriving church community represents another significant travel segment. Several of Alabama's largest and most mission-active congregations are based in Hoover and Vestavia Hills, sending hundreds of volunteers annually to sub-Saharan Africa, Central America, and Southeast Asia. Mission trip teams often have tight departure windows and participants who discover expired passports at registration. International adoption travel — a common need among Hoover families connected to international adoption ministries — creates urgent, non-negotiable passport requirements with unpredictable timelines determined by foreign governments.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center serves Hoover's diverse and internationally active community with the professional, discreet service that executives, physicians, and ministry leaders expect. We handle the complexity — document review, reserved agency submission, case tracking — so Hoover residents can focus on their work, their families, and their missions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Hoover, AL Service Area</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Greater Birmingham south suburbs</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-5 leading-relaxed">
                After signing up online, ship your documents overnight from anywhere in Hoover, Vestavia Hills, Pelham, or Helena. Most clients use a prepaid label we provide — no office visit required for most services.
              </p>
              <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap">
                Start My Passport <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Birmingham's south suburbs — start online, ship overnight, and we handle the rest. No need to drive to Atlanta for a regional agency appointment.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[{ name: "Birmingham", href: "/cities/birmingham" }, { name: "Montgomery", href: "/cities/montgomery-al" }, { name: "Tuscaloosa", href: "/cities/tuscaloosa" }, { name: "Huntsville", href: "/cities/huntsville" }].map((link) => (
                    <a key={link.href} href={link.href} className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap">
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Hoover Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[{ icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" }, { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" }, { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" }, { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" }].map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div>
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}